import { LookUp } from 'src/app/front-user/shared/models/look-up.model';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';
import { BaseUserDto } from './base-user.model';
import { Attachment } from '../../front-user/shared/models/attachment.model';

export class BaseRequest {
    Id: string;
    RequestNumber: string;
    IsCompleted: boolean;
    IsCancelled: boolean;
    IsExpired: boolean;
    IsArrived: boolean;
    RequestorId: string;
    CreationDate: Date;
    ModifiedDate: Date;
    CreatedBy: string;
    ModifiedBy: string;
    ServiceId: number;
    ParentRequestId: string;
    IsDeleted: boolean;
    CancelledBy: string;
    CancelationDate: Date;
    ServiceStepPermissionId: number;
    ReceiverUserName: string;
    StatusId: number;
    StatusEN: string;
    StatusAR: string;
    ServiceNameEN: string;
    ServiceNameAR: string;
    RequestorName : string;
    Service: LookUp;
    Attachments:Attachment[]= [];
    FeesEstimation: FeesEstimate = new FeesEstimate();
    baseUser : BaseUserDto = new BaseUserDto();
}
